 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		134: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"130":"component---src-pages-404-js","131":"component---src-templates-template-item-page-js","132":"component---src-templates-template-page-js"}[chunkId]||chunkId) + "-" + {"0":"b3e73cfa1a39156c430f","1":"1c795a22bedd80a06f2c","2":"abffd3e567772cbd9685","3":"6355c642dae0e08cd017","4":"04bbcd81b513e04735c6","5":"7028df18a337de1a62a6","6":"c5fb2b80e6da83dac1d4","7":"b1ae3b06a3ff70f72269","8":"590c403933615d05aeaf","9":"8635df708e396af67cbd","10":"6bab01de1ddde7d8a37a","11":"5266cb813ead9ced02e5","12":"fc23bf31d76910b8d5f6","13":"13170f00211f22d19f06","14":"46360a4b0e8d0909de8e","15":"c49bdbeeaf016f05dd11","16":"f201009e6c2e55bbfe11","17":"ca097fb939a02c05fd5b","18":"9e6b4c623262c2c028a7","19":"0fe449c8a4e0c0cf34e5","20":"e024555cefdbf82f8c2d","21":"c5b0d47f2e460af696c7","22":"1c2638eca1ec30bc2814","23":"c080070c803f1f77075a","24":"2cd719f5ec7baf38799a","25":"1943da47796c87928669","26":"4f0f29ef16e05881bc64","27":"07ae5e14bfedc47c1c19","28":"2f793479acbb49e30e0e","29":"5a8902b1299409762dda","30":"ef9bd73f6f8bf268a212","31":"1a4c62a22490f75a1549","32":"d2e9faea656f0706adfa","33":"86e47d1957a7d67d2636","34":"2590c8499b85c1a2e169","35":"16fdaaf5a6f121b97492","36":"f3505a4a1cd40787faee","37":"39fca61a0ea892f981a3","38":"960d243efd6a5567b838","39":"49c06dc24585fd124b96","40":"9e7f5aaf8c2019b404c8","41":"8cbab814c19a285c0a26","42":"aa573a33f3b6fdfdaf06","43":"7992d1a3beaf2bc1d152","44":"4662c577a3b031992fa5","45":"5f5c67b31c802eaa40e9","46":"c984573a47c33b573792","47":"66e0b82d90da8c2528e1","48":"5bb55b930b0646bb6a32","49":"0e5fc8e0e1aeb14cd8a8","50":"1ecd004ad8e71f28eabf","51":"b63ac9b1775b0ee17929","52":"4e12013fbd0a58efe237","53":"752b577982a68fb1966d","54":"fdffa00e22ff62af9066","55":"4b1bc0a48bf00a9ff1a7","56":"a7b8c7ab4ef0df5bf742","57":"1367399166ecef6b1c0c","58":"98b2b2bca2d57143625d","59":"ed5e76becf675966969d","60":"7a61a5db1ce251823365","61":"7235d1cbba998c58628c","62":"9db241b93318f2f3c516","63":"e42c6c8093af58277388","64":"71b81b3a3be08bc4d607","65":"f6e79b857cad4052284b","66":"1405da24b603229fe931","67":"39f5af9456ae9bb22d67","68":"c87c8d7530dcb6145b7d","69":"825ba1b70d4e7b8b61bf","70":"fcf186a30b903ee898bd","71":"4e4acd17fc455de45e90","72":"9f1d33bb701685e05032","73":"9844e37a05b979ef0053","74":"e24ede518b3096f811f2","75":"e8a7889ab42d3e744eb6","76":"ba0d683603c4c031a210","77":"aa520f79218439e9bce6","78":"d133484fdb33c859dcd0","79":"f7a5981e04b30d52c18c","80":"efdca363f644cc7dff2a","81":"5d4741f91072a8b35fd4","82":"c9bce5b97f46966cee6b","83":"2edcad6815e2c9f2c7d1","84":"0159378d9bc88c1e55f5","85":"f9967766122898a87096","86":"e2baa18acf6aabc1bbc8","87":"b5c023397b7292fe3722","88":"347591cba2836565f297","89":"1b9bd01b9dedfd4e0d7f","90":"194cf6af4f0eb6d13818","91":"2059800b9313132c28af","92":"fe02b996b149848b5728","93":"e1bd8e796a8b4e8517c1","94":"0b4d8d65436ccb3ebdf4","95":"42b36afafb4b511e9772","96":"18d09a1ab94263ec6ccb","97":"e6778b41a9d624c4dd92","98":"4cb03a557278c87b9aed","99":"6bccc9cad823243b7d42","100":"c993f41e31ba85556947","101":"bc3a86e2ee6af9688f7b","102":"306606133c557cad8678","103":"f99cbde2e6bc92d2a3fc","104":"5405c3ba0597e813a90d","105":"72231946cd22fdb547fb","106":"1984dbf633dc39ddc9f1","107":"679d57d6165d11afe2a6","108":"1b92ecaf9ecd4f1a149d","109":"7b6b62b19ca45d56c8b7","110":"c993189f6d8eeb7b6dfb","111":"e5dacb130b89b32af05e","112":"6fed6c7241780e323fa7","113":"678b72f495041180af75","114":"05b09b3f05c936c1c74b","115":"a0fa22b50687010785f9","116":"c30ca27091fc38e46c75","117":"dff0360361b20bcf0454","118":"3c6401ceb2ac66b86246","119":"90682951e7bde277f3e3","120":"6b5b1f859632312700e6","121":"05af9d21561399f3e1b5","122":"7aaaf5811b8420ad886b","123":"845474e452f188640bbe","124":"89e3283fca5bad67b1d3","125":"fcd31533fbebb79c63e9","130":"040578a760d6e7fe7d5c","131":"599811352cdebaee8e22","132":"4aa7bcce5b416970eada"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
